// export default Authenticate;
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { routes } from '../utils/routes/routes';

const Authenticate = ({ children }: any) => {
  const location = useLocation();
  const navigate = useNavigate();
  const auth = localStorage.getItem('token');
  const path = location?.pathname;
  const currentPath = path?.split('/')[1];

  useEffect(() => {
    if (!auth) {
      navigate(routes.login, { replace: true });
    }
  }, [auth, currentPath, path]);

  return children;
};

export default Authenticate;
